import Service from "../Service";

const resource = "HmnChangeShiftMass/";

export default {

    save(dtr, requestID) {
        return Service.post(resource + "save", dtr, {
            params: { requestID: requestID },
        });
    },
    

    pagination(dtr, requestID) {
        return Service.post(resource + "pagination", dtr, {
            params: { requestID: requestID },
        });
    },

};